export default function () {

    this.load('demo');
};
